import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const css = {
  blurBox: {
    position: 'relative',
    border: '1px solid #FFFFFF80',
    background: `linear-gradient(0deg, rgba(217, 217, 217, 0.2), rgba(217, 217, 217, 0.2)),
                 linear-gradient(90deg, rgba(255, 255, 255, 0.2) 19.85%, rgba(255, 255, 255, 0.100935) 28.63%, rgba(255, 255, 255, 0) 36.84%)`,
    borderRadius: 3,
    mt: '1.3rem',
    backdropFilter: 'blur(15px)',
    boxShadow: '0px 4px 4px 0px #00000040',
    padding: 2,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
};

const BlurBox = ({ children, sx = '' }) => {
  return (
    <Box
      sx={{
        ...sx,
        ...css.blurBox,
      }}
    >
      {children}
    </Box>
  );
};

BlurBox.propTypes = {
  children: PropTypes.element.isRequired,
  sx: PropTypes.string,
};

export default BlurBox;
